export const mapInternalStateToPayload = state => {
  const { name } = state

  return { title: name }
}
